/**
 * Bulk Modal View.
 * View that appear when you click on a bulk tank.
 * Has two main parts: Form (the input part) and the Content (The history of actions).
 * Handles all button input events and validation.
 *
 */

var VRC = VRC || {};

VRC.BulkModalView = (function () {
	var $el;
	var _bulkTank;
	var _masterData;
	var _template = WELL.Handlebars.VRC.bulk_modal;

	var init = function () {
		$el = $('#bulk_modal');
	};

	/**
	 * Sets which field should be sortable in the history view.
	 */
	var attachContentSorting = function () {
		VRC.TableSorterParsers.removeInputFieldListerens('#voyagebulk-content');
		VRC.TableSorterParsers.addInputFieldListeners('#voyagebulk-content');

		var $eventLogTable = $('#voyagebulk-content');
		$eventLogTable.tablesorter({

			headers: {
				0: {sorter: 'datetime'},
				1: {sorter: false},
				2: {sorter: false},
				3: {sorter: false},
				4: {sorter: false},
				5: {sorter: true},
				6: {sorter: false},
				7: {sorter: true},
				8: {sorter: false},
				9: {sorter: false},
				10: {sorter: false},
				11: {sorter: false},
				12: {sorter: false},
				13: {sorter: false},
				14: {sorter: false}
			},
			headerTemplate: '{content} {icon}'
		});
	};
	var render = function (bulkTankId, config) {
		config = config || {};

		if (config.isSpecialTank) {
			_bulkTank = VRC.SpecialBulkTanks.getBulkTankById(bulkTankId);
		}
		else {
			_bulkTank = VRC.BulkTankManager.getBulkTankById(bulkTankId);
		}

		_masterData = _(g_master_data.master_data).clone();
		_masterData.port_list = VRC.MasterDataService.getGroupedPorts();
		_masterData.bulk_clean_type_list = VRC.MasterDataService.getBulkCleanTypes();

		var $content = $el.find('.modal-content');
		var lastAction = _bulkTank.getLastAction();

		if (lastAction) {
			lastAction = lastAction.toJson();
		}

		var cargoEvents = VRC.VoyageLogEntryManager.getCargoEvents();
		var cargoEventsJson = [];
		_.each(cargoEvents, function (cargoEvent) {
			cargoEventsJson.push(cargoEvent.toJson());
		});

		var context = {
			lastAction: lastAction,
			bulkTank: _bulkTank.toJson(),
			cargoEvents: cargoEventsJson,
			masterData: _masterData,
			bulkTanks: VRC.BulkTankManager.getBulkTanksNameAndId(_bulkTank.getBulkTankId()),
			config: config
		};

		$content.html(_template(context));
		attachEvents();
		$el.modal('show', {backdrop: 'static'});
		attachContentSorting();

		$('#addVoyagebulk').submit(function () {
			return false;
		});

	};

	var attachEvents = function () {
		attachAddVoyageBulkEvent();
		attachAddTankCleanEvent();
		attachRemoveEvent();
		attachEditEvent();
		attachRemoveValidationEvent();
		attachDatePickerEvent();
		attachMapEventChange();
		attachChangeAction();
		initSelectize();

	};

	var attachMapEventChange = function () {
		$("#change__cargoEvent").change(function (e) {
			var voyageLogId = $(e.target).val();
			var voyageLog = VRC.VoyageLogEntryManager.getEventById(voyageLogId);

			var $dateField = $("#addVoyagebulk__date");
			var originSelectize = $("#addVoyagebulk__originId")[0].selectize;

			if (voyageLog) {
				$dateField.val(voyageLog.getDateTime());

				originSelectize.setValue(voyageLog.getPort());
			}
			else {
				$dateField.val('');
				originSelectize.setValue('');
			}
		});
	};

	var _$addVoyagebulk__originId;
	var initSelectize = function () {
		_$addVoyagebulk__originId = $("#addVoyagebulk__originId").selectize(VRC.Utils.Selectize.getConfig());
		$("#addVoyagebulk__destinationId").selectize(VRC.Utils.Selectize.getConfig());
		$("#addVoyagebulk__companyId").selectize(VRC.Utils.Selectize.getConfig());
		$("#addVoyagebulk__type").selectize(VRC.Utils.Selectize.getConfig());
	};

	var attachDatePickerEvent = function () {
		$("#addVoyagebulk__date, #addTankClean__date").datetimepicker(
			{
				format: g_timeStampFormat
			});
	};

	var attachRemoveValidationEvent = function () {
		var $inputs = $el.find("#addVoyagebulk").find(':input');

		$inputs.change(function () {
			removeError($(this));
		});

		$('#addVoyagebulk__date').on('dp.change', function (ev) {
			removeError($(this));
		});

	};

	var _errorMessages = {
		date: 'Required format: ' + g_timeStampFormat,
		startRobIsAfter: 'Start rob cannot be added after other events',
		originId: 'Origin is required',
		sgRequired: 'When unit m3 is set, SG is required',
		sgRange: 'Sg outside valid range [0.1-3.0]',
		offloadDestination: 'The can be no destination on offload. Use Origin.',
		valueQty: 'Qty is required',
		positiveQty: 'Qty has to be a positive number',
		vesselOffload: 'Destination can not be set when transferring Bulk to another vessel. Please use Origin'
	};

	var hasValue = function (value) {
		return value !== undefined && value !== '';
	};

	var isBetween = function (value, min, max) {
		try {
			parseFloat(value);
			return value >= min && value <= max;
		}
		catch (e) {
			return false;
		}
	};

	var showErrors = function ($form, errors) {
		$.each(errors, function (name, error) {
			showError($form, name, error)
		});
	};

	var removeErrors = function(){
		var inputs = $('#addVoyagebulk').find(':input');;
		$.each(inputs, function(key,input){
			removeError(input);
		});
	};

	var removeError = function ($input) {
		var $formGroup = $($input.closest('.form-group'));

		if($formGroup){
			$formGroup.removeClass('has-error');
			$formGroup.find('.help-block').remove();
		}

	};

	var showError = function ($form, name, error) {
		var $input = getElement($form, name);
		removeError($input);
		var $formGroup = $input.parent();
		$formGroup.addClass('has-error');
		$formGroup.append(createErrorMessage(error));
	};

	var getElement = function ($form, name) {
		return $form.find(':input[name="' + name + '"]');
	};

	var isValidDate = function (date) {
		return moment(date, g_timeStampFormat, true).isValid();
	};

	var checkForVoyageBulkErrors = function (data) {
		var errors = {};

		if (!isValidDate(data.date)) {
			errors.date = _errorMessages.date;

		}
		else {
			if (data.action === g_actions.start_rob) {
				var firstEvent = _bulkTank.getFirstContentIgnoreStartRob();

				if (firstEvent) {
					var firstDate = moment(firstEvent.getDate(), g_timeStampFormat);
					var isValid = moment(data.date, g_timeStampFormat).isBefore(firstDate);
					if (!isValid) {
						errors.date = _errorMessages.startRobIsAfter;
					}
				}
			}
		}
		if (data.action !== g_actions.start_rob) {
			if (!hasValue(data.originId) && (!hasValue(data.vessel))) {
				errors.originId = _errorMessages.originId;
			}
			if (data.valueUnit === 'm3') {
				if (!hasValue(data.sg)) {
					errors.sg = _errorMessages.sgRequired;
				}
				else if (!isBetween(data.sg, 0.1, 3.0)) {
					errors.sg = _errorMessages.sgRange;
				}
			}

		}
		if (!hasValue(data.valueQty)) {
			errors.valueQty = _errorMessages.valueQty;
		}
		else if (data.valueQty < 0 && data.action !== g_actions.deviation) {
			errors.valueQty = _errorMessages.positiveQty;
		}

		if (data.action === g_actions.offload) {
			if (data.destinationId) {
				errors.destinationId = _errorMessages.offloadDestination;
			}
		}

		if (isNaN(VRC.Utils.Number.parseInt(data.originId)) || isNaN(VRC.Utils.Number.parseInt(data.destinationId))) {
			if (data.destinationId) {
				errors.destinationId = _errorMessages.vesselOffload;
			}
		}

		return errors;
	};

	var checkForTankCleanErrors = function (data) {
		var errors = {};

		if (!isValidDate(data.date)) {
			errors.date = _errorMessages.date;
		}

		return errors;
	};

	var isValid = function (errors) {
		return jQuery.isEmptyObject(errors);
	};

	var createErrorMessage = function (error) {
		return $('<span class="help-block with-errors">' + error + '</span>');
	};

	var getContent = function () {
		return $el.find('#voyagebulk-content tbody');
	};

	var renderContent = function () {
		var bulkJson = _bulkTank.toJson();
		var ctx = bulkJson;

		var html = Handlebars.partials['bulk_modal_content'](ctx);
		var $content = getContent();
		$content.html(html);
		attachRemoveEvent();
		attachEditEvent();

		var $voyageBulkTable = $('#voyagebulk-content');
		$voyageBulkTable.trigger("update");
		$voyageBulkTable.trigger("appendCache");
	};

	var updateVoyageBulk = function (onSucess) {
		var $voyageForm = $el.find("#addVoyagebulk");
		var $inputElements = $voyageForm.find(':input');
		var serializedObject = VRC.Utils.Forms.serializeObject($inputElements);

		var errors = checkForVoyageBulkErrors(serializedObject);

		if (isValid(errors)) {

			onSucess(serializedObject);

			renderContent();
			VRC.BulkStateView.renderTank(_bulkTank);
			VRC.BulkState.saveToLocalStorage();
			VRC.BulkOffloadAraeView.init();
			VRC.BulkLoadingAreaView.init();

		}
		else {
			showErrors($voyageForm, errors);
		}
	};

	var attachAddVoyageBulkEvent = function () {

		var $btn = $el.find("#addVoyagebulk__add-btn");

		$btn.unbind('click').click(function (e) {
			e.preventDefault();

			var onSuccess = function (serializedObject) {
				var action = serializedObject.action;
				var voyageBulk = VRC.VoyageBulk(serializedObject);
				_bulkTank.addContent(voyageBulk);

				if (isTransferAction(action)) {
					createTransferAction(action, serializedObject.transferToTank, serializedObject);
				}

				renderForm();
				attachDatePickerEvent();

			};

			updateVoyageBulk(onSuccess);
		});
	};

	var createTransferAction = function (action, bulkTankId, voyageBulk) {
		bulkTankId = parseInt(bulkTankId);
		var clone = VRC.VoyageBulk(voyageBulk);
		var bulkTank = VRC.BulkTankManager.getBulkTankById(bulkTankId);
		if (action === 'transfer_to') {
			clone.setAction('transfer_from');

		}
		else if (action === 'transfer_from') {
			clone.setAction('transfer_to');
		}

		else {
			console.error('invalid action');
			return;
		}
		bulkTank.addContent(clone);
		VRC.BulkStateView.renderTank(bulkTank);
	};

	var attachUpdateVoyageBulkEvent = function () {

		var $btn = $el.find("#addVoyagebulk__edit-btn");

		$btn.unbind('click').click(function (e) {
			e.preventDefault();

			var onSuccess = function (serializedObject) {
				var voyageBulk = _bulkTank.getContentById(serializedObject.voyageBulkId);
				voyageBulk.update(serializedObject);
				_bulkTank.recalcRob();
				renderForm();
				attachDatePickerEvent();
			};

			updateVoyageBulk(onSuccess);

		});
	};

	var _tempAction = '';

	var attachChangeAction = function ($row) {
		var invalidDestinationActions = ['offload', 'tank_clean_started', 'tank_clean', 'dump'];
		var $action = $("#addVoyagebulk__action");

		$action.unbind('change').change(function (e) {
			var $field = $(e.target);
			var action = $field.val();
			var $destinationField = $("#addVoyagebulk__destinationId");
			var $destinationSelectize = $destinationField[0].selectize;
			if (_.contains(invalidDestinationActions, action)) {

				_tempAction = $destinationField.val();
				var $destinationSelectize = $destinationField[0].selectize;
				$destinationSelectize.setValue('');
				$destinationSelectize.disable();
			}
			else if (action === '') {

			}
			else {
				$destinationSelectize.enable();
				$destinationSelectize.setValue(_tempAction);
				_tempAction = '';
			}

			showActionFields(action);

		});
	};

	var showActionFields = function (action) {
		switch (action) {
			case 'transfer_to':
			case 'transfer_from':
				showActionField("#addVoyagebulk__transferToTank");
				break;
			case 'tank_clean_started':
			case 'tank_clean':
				showActionField('#addVoyagebulk__actionObject');
				break;
			default:
				showActionField(null);
		}
	};

	var isTransferAction = function (action) {
		var invalidDestinationActions = ['transfer_to', 'transfer_from'];
		return _.contains(invalidDestinationActions, action)
	};

	var actionFieldsMap = ["#addVoyagebulk__transferToTank", '#addVoyagebulk__actionObject'];

	var showActionField = function (actionDiv) {
		_.map(actionFieldsMap,function(actionField) {
			var $row = $(actionField).parent();
			if (actionField === actionDiv) {
				$row.show();
			} else {
				$row.hide();
			}
		});
	};

	var attachUpdateVoyageBulkCancelEvent = function () {

		var $btn = $el.find("#addVoyagebulk__edit-cancel-btn");

		$btn.unbind('click').click(function (e) {
			e.preventDefault();

			renderForm();
			attachDatePickerEvent();

		});
	};

	var attachAddTankCleanEvent = function () {
		var $btn = $el.find("#addTankClean__add-btn");
		var $tankCleanForm = $el.find("#addTankClean");
		var $inputElements = $tankCleanForm.find(':input');
		$btn.unbind('click').click(function (e) {
			e.preventDefault();
			var serializedObject = VRC.Utils.Forms.serializeObject($inputElements);

			var errors = checkForTankCleanErrors(serializedObject);

			if (isValid(errors)) {
				var voyageBulk = VRC.VoyageBulk(serializedObject);
				_bulkTank.addContent(voyageBulk);
				renderContent();
				VRC.BulkStateView.renderTank(_bulkTank);
				VRC.BulkOffloadAraeView.init();
				VRC.BulkState.saveToLocalStorage();
			}
			else {
				showErrors($tankCleanForm, errors);
			}
		});
	};

	var attachEditEvent = function () {
		var $content = getContent();
		var $btns = $content.find('.voyagebulk-content__edit-btn');
		$btns.unbind('click').click(function (e) {
			e.preventDefault();
			var $row = $(this).closest('tr');
			var voyageBulkId = $row.attr('data-voyagebulk-id');

			renderForm(voyageBulkId);
		});

	};

	var renderForm = function (objectId, objectType) {
		objectType = objectType || 'bulk';
		var $form = $('#addVoyagebulk');
		var config = {};
		var voyageBulk;

		if (objectId && objectType === 'bulk') {
			config.editMode = true;
			voyageBulk = _bulkTank.getContentById(objectId);
		}
		else {
			voyageBulk = _bulkTank.getLastAction();
		}

		if (voyageBulk) {

			var ctx = {
				lastAction: voyageBulk.toJson(),
				bulkTank: _bulkTank.toJson(),
				masterData: _masterData,
				config: config,
				bulkTanks: VRC.BulkTankManager.getBulkTanksNameAndId(_bulkTank.getBulkTankId())
			};

			var html = Handlebars.partials['bulk_modal_voyagebulk_form'](ctx);
			$form.replaceWith(html);
		}
		else {
			$el.modal('hide')
		}
		attachUpdateVoyageBulkEvent();
		attachUpdateVoyageBulkCancelEvent();

		attachAddVoyageBulkEvent();
	};

	var attachRemoveEvent = function () {
		var $content = getContent();
		var $btns = $content.find('.voyagebulk-content__remove-btn');
		$btns.unbind('click').click(function (e) {
			e.preventDefault();
			var $row = $(this).closest('tr');
			var voyageBulkId = $row.attr('data-voyagebulk-id');

			var voyageBulk = _bulkTank.getContentById(voyageBulkId);

			if (voyageBulk.getContainerId() && voyageBulk.getAction() === g_actions.load) {
				var bulkRequest = VRC.BulkCargoRequestManager.getBulkCargoRequestById(voyageBulk.getContainerId());
				if (bulkRequest) {
					bulkRequest.subtractValueQty(voyageBulk.getValueQty() * -1)
				}
			}

			_bulkTank.removeContent(voyageBulk);

			renderContent();
			VRC.BulkStateView.renderTank(_bulkTank);
			VRC.BulkOffloadAraeView.init();
			VRC.BulkLoadingAreaView.init();
		});
	};



	return {
		init: init,
		render: render,
		removeErrors : removeErrors
	};

})();
